import { takeLatest, call, put } from 'redux-saga/effects';
import { request } from './api';
import { REQUEST_BY_ID } from '../queries';
import { client } from '../modules/apollo';

import {
  FETCH_EVENT_REQUESTS,
  GET_ALL_EVENT_REQUESTS,
  FETCH_EVENT_REQUEST,
  GET_EVENT_REQUEST,
  FETCH_EVENT_REQUEST_START,
  GET_EVENT_REQUEST_UNREAD_MESSAGES,
  FETCH_EVENT_REQUEST_UNREAD_MESSAGES,
  FETCH_EVENT_REQUEST_ERROR,
} from '../constants/action-types';

interface FetchRequestsAction {
  eventId: string;
  type: string;
}

interface FetchRequestAction {
  requestId: string;
  type: string;
}

interface RequestResponse {
  data: {
    result: {
      robex: any[];
      [key: string]: any;
    };
  };
}

interface RequestOptions {
  url: string;
  method: string;
}

function* fetchRequests({
  eventId,
}: FetchRequestsAction): Generator<any, void, any> {
  const requests = yield call(request, {
    url: `/event-requests/${eventId}/event`,
    method: 'GET',
  } as RequestOptions);

  yield put({
    type: FETCH_EVENT_REQUESTS,
    payload: requests,
  });
}

function* fetchRequest({
  requestId,
}: FetchRequestAction): Generator<any, void, any> {
  yield put({
    type: FETCH_EVENT_REQUEST_START,
  });

  try {
    const response: RequestResponse = yield call(client.query, {
      query: REQUEST_BY_ID,
      variables: { filter: { requestId } },
      fetchPolicy: 'network-only',
    });

    yield put({
      type: FETCH_EVENT_REQUEST,
      payload: response.data.result,
    });
  } catch (err) {
    yield put({ type: FETCH_EVENT_REQUEST_ERROR, payload: err.response });
  }
}

function* fetchEventRequestUnreadMessages({
  requestId,
}: FetchRequestAction): Generator<any, void, any> {
  const unreadMessages = yield call(request, {
    url: `/conversations/unreadCountForRequest/${requestId}`,
    method: 'GET',
  } as RequestOptions);

  yield put({
    type: FETCH_EVENT_REQUEST_UNREAD_MESSAGES,
    payload: unreadMessages,
  });
}

export default function* eventRequestSaga(): Generator<any, void, any> {
  yield takeLatest(GET_ALL_EVENT_REQUESTS, fetchRequests);
  yield takeLatest(GET_EVENT_REQUEST, fetchRequest);
  yield takeLatest(
    GET_EVENT_REQUEST_UNREAD_MESSAGES,
    fetchEventRequestUnreadMessages
  );
}
